
import React from "react"
import SocialIcons from "./social-icons"
import Icon from "./icon"
import { Link } from "gatsby"

function Footer() {
  return (
    <footer className="px-4 pt-12 pb-4 text-white bg-neutral-900 md:pb-12">
      <div className="container flex flex-col justify-between md:flex-row">
        <div className="flex flex-col gap-3.5">
          <span className="flex items-center gap-8">
            <SocialIcons />
          </span>
        </div>
        <div className="mt-11 flex flex-col gap-3.5 md:mt-0">
          {/* TODO: parameterize e-mail */}
          {/* TODO: hide e-mail? */}
          <span className="text-xs font-light lowercase text-white"><a href="mailto:hello@extremeautomation.io" target="_blank" rel="noopener"><Icon id="email-white" size={28} className="inline-block mr-1 -mt-1" /> {"hello@extremeautomation.io"}</a></span>
        </div>
      </div>
      <div className="container flex flex-col justify-between md:flex-row">
        <a href="#top" className="flex items-center gap-2 font-medium mt-14 text-rose-400 md:order-1 md:mt-10">
          <svg role="presentation" width="13" height="8" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M6.364 2.828 2.121 7.071A1 1 0 0 1 .707 5.657L6.364 0l5.657 5.657a1 1 0 1 1-1.414 1.414L6.364 2.828Z" fill="#E46977" />
          </svg>
          Beam me up, Scotty!
        </a>
        <small className="block text-xs font-light text-center mt-11">Copyright © 2012-{new Date().getFullYear()} Aestas/IT. All rights reserved.</small>
        <Link to="/privacy/"><small className="block text-xs font-light text-center mt-11">Privacy Policy.</small></Link>
      </div>
    </footer>
  )
}

export default Footer
